import { Body as e, H2 as t } from "../../Typography/Typography.mjs";
import { Icons as n } from "../Icons/Icons.mjs";
import { Actions as r, IconChip as i, Wrapper as a } from "./NotFoundView.styled.mjs";
import "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/NotFoundView/NotFoundView.tsx
var c = ({ title: c, description: l, icon: u, children: d }) => /* @__PURE__ */ s(a, { children: [
	/* @__PURE__ */ o(i, { children: u ?? /* @__PURE__ */ o(n.Compass, {
		size: 32,
		strokeWidth: 1.5
	}) }),
	/* @__PURE__ */ o(t, { children: c }),
	/* @__PURE__ */ o(e, {
		color: "secondary",
		children: l
	}),
	d && /* @__PURE__ */ o(r, { children: d })
] });
//#endregion
export { c as NotFoundView };
